export default "__VITE_ASSET__CThpQkqd__"